import React from 'react'
import Fragment from '../common/fragment'


function FragmentBY(props) {
  return (
    <Fragment pos="yy" {...props}>
      <p>
      La última pintura del siglo. Después, un silencio monocromo. Los rollos del Mar
Muerto. Interpretaciones pendientes del Torá. Un cuadro escueto y una visión solar.
Negro sobrenegro sobrenegro sobrenegro. El blanco es el infinito que sostiene una
oscuridad absoluta. ¿O el negro sostiene el blanco al dispersarse en la luz? Si usted
trata de girar el cuadro se dará cuenta de que no hay arribaniabajo y que todo es un
círculo en espera de que lo roten. Negronoche, negropetróleo, negrooscuridad,
negrocristo, negroespaciosideral. No hables de la ausencia de color, mejor di que
nada se puede entender sin el contraste entre las superficies comprensibles de la
realidad y las formas inesperadas de la sorpresa. Este cuadro calla. El blanco es
blanco/el negro es negro.
      </p>
    </Fragment>
  )
}


export default FragmentBY
